import React, { useRef, useState, useEffect } from 'react';
import Header from '../component/Header';
import bannerImage from './../assets/images/bg.jpg';
import { Container, Row, Col, Alert, Table } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import visaMasterImage from './../assets/images/visa-master.png';
import directDebit from './../assets/images/directdebit.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot, faPlus, faMinus, faChevronDown, faCheck, faArrowRight, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Form from 'react-bootstrap/Form';
// import userData from './../testdata.json';
import {
    setPlans, setAddons, setTotalPrice, setFullPrice, setMonthlyPrice, setMonthlyRepayment, setDepositPrice,
    setTotaChargeCredit, setBrokerFee, setSelectInsurerTypes, setAIDepositPrice, setAIMonthlyRepayment, setAIFullPrice,
    setAIMonthlyFull, setUserEmail, setSelectAiInsurerTypes, setAiTotaChargeCredit
} from './../store/paymentSummery/paymentSummeryActions';
import { useDispatch, useSelector } from 'react-redux';
import LeftMenu from '../component/LeftMenu';
import { useNavigate } from 'react-router-dom';
import Loading from '../component/Laoding';
import legalIcon from './../assets/images/legal.png';
import emergencyIcon from './../assets/images/House.png';
import keyIcon from './../assets/images/Security.png';
import gadgetIcon from './../assets/images/Gadget.png';
import MonekPaymentForm from '../component/MonekPaymentForm';
import Footer from '../component/Footer';
import ReviewQuoteDetails from '../component/ReviewQuoteDetails';
// import { UserDetails } from '../store/user/userActions';
// import { encryptStorage } from '../utils/storage';






const Product = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedAddons, setSelectedAddons] = useState([]);
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [summaryData, setSummaryData] = useState({});
    const [error, setError] = useState('');
    const [productBothPrices, setProductBothPrices] = useState(false);
    const [showAlternativePrices, setShowAlternativePrices] = useState(false);
    const [formSubmit, setFormSubmit] = useState(false);
    const [selectAiInsurerType, setSelectAiInsurerType] = useState({ type: 'currentInsurer' })

    // const token = encryptStorage.getItem('b68f38dbe5a2');
    // console.log(token)
    const userData = useSelector((state) => state.user.user);
    const userLoginType = useSelector((state) => state.user.loginType);
    const loading = useSelector((state) => state.user.loading);
    // Reference to the summary section
    const summaryRef = useRef(null);
    const termsRef = useRef(null);

    // const summaryData = {
    //     premium: userData?.PaymentDetails?.CurrentInsurerPremium,
    //     premiumTotal: userData?.PaymentDetails?.CurrentInsurerTotal,
    //     currentInsurerCharge: userData?.PaymentDetails?.CurrentInsurerCharge,
    //     policyDiscount: 40.00,
    //     deposit: userData?.PaymentDetails?.Deposit,
    //     interest: userData?.PaymentDetails?.Interest,
    //     payments: userData?.PaymentDetails?.Payments,
    //     monthlyRepayment: 43.52,
    //     totalChargeForCredit: 58.80,
    // };

    const currentInsurerCharge = userLoginType === "Failed Payment" || userLoginType === "Lapse" ?
        parseFloat(userData?.PaymentDetails?.Charge || "0") :
        parseFloat(userData?.PaymentDetails?.CurrentInsurerCharge || "0") === 0 ?
            parseFloat(userData?.PaymentDetails?.AlternativeInsurerCharge || "0") :
            selectAiInsurerType.type === 'alternativeInsurer' ? parseFloat(userData?.PaymentDetails?.AlternativeInsurerCharge || "0") : parseFloat(userData?.PaymentDetails?.CurrentInsurerCharge || "0");

    const isBrokerDiscount = currentInsurerCharge < 0;

    // console.log(isBrokerDiscount)

    useEffect(() => {
        if (userData?.PaymentDetails) {
            const currentPremium = userLoginType === "Lapse" ?
                parseFloat(userData.PaymentDetails.Premium || "0") :
                parseFloat(userData.PaymentDetails.CurrentInsurerPremium || "0");
            const alternativePremium = parseFloat(userData.PaymentDetails.AlternativeInsurerPremium || "0");
            const premiumFailed = parseFloat(userData.PaymentDetails.Premium || "0");

            let displayData = {};


            if (!currentPremium && userLoginType !== "Failed Payment" && userLoginType !== "Lapse") {
                displayData = {
                    showAlternative: true,
                    alternativePremium,
                };
                setShowAlternativePrices(true);

            } else if (!alternativePremium || currentPremium <= alternativePremium) {
                displayData = {
                    showCurrent: true,
                    currentPremium,
                };
            } else {
                displayData = {
                    showBoth: true,
                    currentPremium,
                    alternativePremium,
                };
                setProductBothPrices(true)
            }

            setSummaryData({
                premium: userLoginType === "Failed Payment" || userLoginType === "Lapse" ? premiumFailed : currentPremium === 0 ? alternativePremium : currentPremium,
                alternativepremium: parseFloat(userData.PaymentDetails.AlternativeInsurerTotal || "0"),
                premiumTotal: userLoginType === "Failed Payment" || userLoginType === "Lapse" ? premiumFailed : parseFloat(userData.PaymentDetails.CurrentInsurerTotal || "0") === 0 ? parseFloat(userData.PaymentDetails.AlternativeInsurerTotal || "0") : parseFloat(userData.PaymentDetails.CurrentInsurerTotal || "0"),
                policyDiscount: 10.00,
                deposit: parseFloat(userData.PaymentDetails.Deposit || "0"),
                interest: parseFloat(userData.PaymentDetails.Interest || "0"),
                payments: parseFloat(userData.PaymentDetails.Payments || "0"),
                // currentInsurerCharge: userLoginType === "Failed Payment" ? parseFloat(userData.PaymentDetails.Charge || "0") : parseFloat(userData.PaymentDetails.CurrentInsurerCharge || "0"),
                monthlyRepayment: 43.52,
                totalChargeForCredit: 58.80,
                ...displayData, // Merging the insurer logic
            });
        }
    }, [userData, userLoginType, summaryData, currentInsurerCharge]);



    const addonPrices = {
        legal: userData?.AddonPrices?.Legal,
        emergency: userData?.AddonPrices?.Emergency,
        key: userData?.AddonPrices?.Key,
        gadget: userData?.AddonPrices?.Gadget
    };
console.log("Gadget Price:", userData?.AddonPrices?.Gadget);
    const addonMonthlyPrices = {
        legal: userData?.AddonPrices?.Legal,
        emergency: userData?.AddonPrices?.Emergency,
        key: userData?.AddonPrices?.Key,
        gadget: userData?.AddonPrices?.Gadget
    }


    // useEffect(() => {
    //     if (userData?.PaymentDetails) {
    //         const preSelected = [];
    //
    //         // Helper to safely check if the value is greater than 0
    //         // We use parseFloat because the XML/JSON likely returns strings like "19.95"
    //         const isActive = (val) => parseFloat(val || "0") > 0;
    //
    //         // Check specific XML tags from PaymentDetails and map them to your lowercase keys
    //         if (isActive(userData.PaymentDetails.Legal)) preSelected.push('legal');
    //         if (isActive(userData.PaymentDetails.Emergency)) preSelected.push('emergency');
    //         if (isActive(userData.PaymentDetails.Key)) preSelected.push('key');
    //         if (isActive(userData.PaymentDetails.Gadget)) preSelected.push('gadget');
    //
    //         // Only update state if we actually found active addons to avoid infinite loops
    //         if (preSelected.length > 0) {
    //             setSelectedAddons(preSelected);
    //             dispatch(setAddons(preSelected));
    //         }
    //     }
    // }, [userData, dispatch]);

    // Function to calculate monthly payment for an add-on
    const calculateMonthlyPayment = (amount) => {
        const deposit = (amount * Number(summaryData.deposit)) / 100;
        const remaining = amount - deposit;
        const totalWithInterest = remaining + remaining * Number(summaryData.interest) / 100;
        return totalWithInterest / Number(summaryData.payments);
    };

    // Transform the data to match the desired structure
    const addonMonthlyPayments = Object.fromEntries(
        Object.entries(addonMonthlyPrices).map(([addon, price]) => {
            const monthlyPayment = calculateMonthlyPayment(price);
            return [addon, parseFloat(monthlyPayment.toFixed(2))]; // Key-value pair with rounded value
        })
    )

    const toggleAddon = (addon) => {
        const isSelected = selectedAddons.includes(addon);
        const updatedAddons = isSelected ? selectedAddons.filter((item) => item !== addon) : [...selectedAddons, addon];
        setSelectedAddons(updatedAddons);
        dispatch(setAddons(updatedAddons));
        // if (summaryRef.current) {
        //     summaryRef.current.scrollIntoView({ behavior: 'smooth' });
        // }
    };

    const premiumBrokerDiscountMonthly = userLoginType === "Failed Payment" || userLoginType === "Lapse" ? isBrokerDiscount ? Number(summaryData.premiumTotal) - Math.abs(Number(currentInsurerCharge)) : Number(summaryData.premiumTotal) + Math.abs(Number(currentInsurerCharge)) : Number(summaryData.premiumTotal);
    const totaladdon = selectedAddons.reduce((acc, addon) => acc + Number(addonPrices[addon]), 0);
    const monthlyaddonTotal = premiumBrokerDiscountMonthly + totaladdon;
    // console.log(monthlyaddonTotal)
    // Monthly Payment Section
    const depositAmount = monthlyaddonTotal * Number(summaryData.deposit) / 100;
    const calculateRemaining = monthlyaddonTotal - depositAmount;
    const interestRate = calculateRemaining * Number(summaryData.interest) / 100;
    const calculateTotalMonthlyPayment = calculateRemaining + interestRate;
    const monthlyRepayment = calculateTotalMonthlyPayment / Number(summaryData.payments);
    // const addonMonthly = selectedAddons.reduce((acc, addon) => acc + Number(addonMonthlyPayments[addon]), 0);
    const monthlyRepaymentTotal = monthlyRepayment;
    const totalPayMonthly = depositAmount + monthlyRepaymentTotal * Number(summaryData.payments);

    // console.log(monthlyRepaymentTotal)

    const aIpremiumBrokerDiscountMonthly = userLoginType === "Failed Payment" || userLoginType === "Lapse" ? isBrokerDiscount ? Number(summaryData.alternativepremium) - Math.abs(Number(currentInsurerCharge)) : Number(summaryData.alternativepremium) + Math.abs(Number(currentInsurerCharge)) : Number(summaryData.alternativepremium);
    const aItotaladdon = selectedAddons.reduce((acc, addon) => acc + Number(addonPrices[addon]), 0);
    const aImonthlyaddonTotal = aIpremiumBrokerDiscountMonthly + aItotaladdon;
    // Monthly Alternative Insurer Payment Section
    const aIdepositAmount = aImonthlyaddonTotal * Number(summaryData.deposit) / 100;
    const aIcalculateRemaining = aImonthlyaddonTotal - aIdepositAmount;
    const aIinterestRate = aIcalculateRemaining * Number(summaryData.interest) / 100;
    const aIcalculateTotalMonthlyPayment = aIcalculateRemaining + aIinterestRate;
    const aImonthlyRepayment = aIcalculateTotalMonthlyPayment / Number(summaryData.payments);
    // const aIaddonMonthly = selectedAddons.reduce((acc, addon) => acc + Number(addonMonthlyPayments[addon]), 0);
    const aImonthlyRepaymentTotal = aImonthlyRepayment;
    const aItotalPayMonthly = aIdepositAmount + aImonthlyRepaymentTotal * Number(summaryData.payments);

    // Full Payment Section

    const premiumBrokerDiscount = userLoginType === "Failed Payment" || userLoginType === "Lapse" ? isBrokerDiscount ? Number(summaryData.premiumTotal) - Math.abs(Number(currentInsurerCharge)) : Number(summaryData.premiumTotal) + Math.abs(Number(currentInsurerCharge)) : Number(summaryData.premiumTotal);
    const addonTotal = selectedAddons.reduce((acc, addon) => acc + Number(addonPrices[addon]), 0);
    const totalPayInFull = premiumBrokerDiscount + addonTotal;

    const aipremiumBrokerDiscount = userLoginType === "Failed Payment" || userLoginType === "Lapse" ? isBrokerDiscount ? Number(summaryData.alternativepremium) - Math.abs(Number(currentInsurerCharge)) : Number(summaryData.alternativepremium) + Math.abs(Number(currentInsurerCharge)) : Number(summaryData.alternativepremium);
    const alternativeTotalPayInFull = aipremiumBrokerDiscount + addonTotal;
    // console.log(1+addonTotal)
    // Calculate total price
    const calculateTotalPrice = () => {
        // const addonTotal = selectedAddons.reduce((acc, addon) => acc + addonPrices[addon], 0);
        const baseTotal =
            (userData?.PaymentDetails?.CurrentInsurerTotal || 0) +
            (userData?.PaymentDetails?.Interest || 0) +
            (userData?.PaymentDetails?.Payments || 0) -
            (userData?.PaymentDetails?.Deposit || 0);
        const totalPrice = baseTotal;
        dispatch(setTotalPrice(totalPrice)); // Dispatch total price
        return totalPrice;
    };

    // Handle checkbox toggle
    const handleCheckboxChange = (e) => {
        setIsTermsChecked(e.target.checked);
        setError('');
    };

    const [plan, setPlan] = useState({ type: 'yearly', price: totalPayInFull });
    const [selectInsurerType, setSelectInsurerType] = useState({ type: 'currentInsurer', price: totalPayInFull });
    const [hideBothProductPopup, setHideBothProductPopup] = useState(false);
    // Handle change when user selects a plan
    const handlePlanChange = (e) => {
        const selectedPlan = e.target.value === 'monthly' ? { type: 'monthly', price: totalPayMonthly } : { type: 'yearly', price: totalPayInFull };
        setPlan(selectedPlan);
        dispatch(setPlans(selectedPlan)); // Dispatch selected plan
    };

    const handelSelectInsurerType = (e) => {
        const selectedRadio = document.querySelector('input[name="bothPrice"]:checked');

        if (!selectedRadio) {
            setError("Please select insurer.");
            return;
        }

        const selectedValue = selectedRadio.value;
        const insurerselectedPlan = selectedValue === 'currentInsurer'
            ? { type: 'currentInsurer', price: totalPayInFull }
            : { type: 'alternativeInsurer', price: alternativeTotalPayInFull };

        setSelectInsurerType(insurerselectedPlan);
        setSelectAiInsurerType(insurerselectedPlan)
        setHideBothProductPopup(true);
        setError("");
    }


    const [email, setEmail] = useState(userData?.HomeDetails?.["Email"] || '');
    const [emailError, setEmailError] = useState('');
    const [checkEmail, setCheckEmail] = useState(false);
    const [checkEmailError, setCheckEmailError] = useState('');

    const validateEmail = (email) => {
        // Basic email regex pattern
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleEmailCheckboxChange = (e) => {
        setCheckEmail(e.target.checked);
        setCheckEmailError('');
    };


    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        // Check if terms & conditions checkbox is checked
        if (!isTermsChecked) {
            setError('You must agree to the Terms & Conditions to proceed.');
            if (termsRef.current) {
                termsRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }
        if (isTermsChecked) {
            setError('I confirm that I have read and agree with the terms & conditions.');
        }

        // Proceed to payment process
        setError(''); // Clear any previous errors

        if (!checkEmail) {
            setCheckEmailError('Please confirm your email.');
            if (termsRef.current) {
                termsRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }
        setCheckEmailError('');
        // Get the selected plan type and price
        console.log(`Price: £${calculateTotalPrice()}, Add-ons: ${selectedAddons.join(', ')}`);
        // alert(`Selected Plan: ${plan.type}, Price: $${calculateTotalPrice()}, Add-ons: ${selectedAddons.join(', ')}`);
        // Reset error
        setEmailError('');

        // Validation
        if (!email) {
            setEmailError('Email is required');
            return;
        }

        if (!validateEmail(email)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        if (plan.type === 'monthly') {
            navigate('/bankdetails', { replace: true });
        } else {
            const paymentModel = {
                Reference: refData.referenceCode,
                Name: userData?.ProposerDetails?.[1]
                    ? `${userData?.ProposerDetails?.[0]?.["Proposer.Person.Title"]} ${userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"]} ${userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"]}`
                    : `${userData?.ProposerDetails?.["Proposer.Person.Title"]} ${userData?.ProposerDetails?.["Proposer.Person.Forenames"]} ${userData?.ProposerDetails?.["Proposer.Person.Surname"]}`,
                Address1: userData?.HomeDetails?.["Home.Address.AddrLine1"],
                Address2: userData?.HomeDetails?.["Home.Address.AddrLine2"],
                Address3: userData?.HomeDetails?.["Home.Address.AddrLine3"],
                Address4: userData?.HomeDetails?.["Home.Address.AddrLine4"],
                Postcode: userData?.HomeDetails?.["Home.Address.AddrPostCode"],

                TotalToPay: productBothPrices
                    ? (selectInsurerType.type === 'currentInsurer' ? parseFloat(totalPayInFull).toFixed(2) : parseFloat(alternativeTotalPayInFull).toFixed(2))
                    : parseFloat(totalPayInFull).toFixed(2),

                Email: email,
                PaymentReference: refData.referenceCode,
                currentInsurerCharge: currentInsurerCharge.toFixed(2),
                pReturn: userLoginType,
                pRef: refData.referenceCode,
                pCode: userData?.HomeDetails?.["Home.Address.AddrPostCode"],
                payment: selectInsurerType.type === 'alternativeInsurer' ? summaryData.alternativepremium : summaryData.premium,
                Insurer: productBothPrices ? selectInsurerType.type === 'alternativeInsurer' ? userData?.PaymentDetails?.AlternativeInsurer : userData?.HomeDetails?.Insurer
                    : userData?.PaymentDetails?.AlternativePolicyWording && userData?.PaymentDetails?.AlternativeInsurer ? userData?.PaymentDetails?.AlternativeInsurer : userData?.HomeDetails?.Insurer,
                phone: userData?.HomeDetails?.Telephone1,
                schemeCode: userData?.HomeDetails?.SchemeCode,
                coverDate: userData?.HomeDetails?.["Policy.CoverDate"],
                legalPurchased: addonStatus.legalPurchased,
                emergencyPurchased: addonStatus.emergencyPurchased,
                keysPurchased: addonStatus.keysPurchased,
                gadgetPurchased: addonStatus.gadgetPurchased
            };
            navigate('/payment', { replace: true, state: { paymentModel } });
        }

    };

    const diffrentBetweenYearlyAndMonthly = totalPayMonthly - totalPayInFull;
    const diffrentBetweenYearlyAndMonthlyAi = aItotalPayMonthly - alternativeTotalPayInFull;

    useEffect(() => {
        setSelectInsurerType(selectInsurerType)
        dispatch(setPlans(plan));
        dispatch(setFullPrice(totalPayInFull));
        dispatch(setMonthlyPrice(totalPayMonthly));
        dispatch(setDepositPrice(depositAmount));
        dispatch(setMonthlyRepayment(monthlyRepaymentTotal));
        dispatch(setTotaChargeCredit(diffrentBetweenYearlyAndMonthly.toFixed(2)));
        dispatch(setBrokerFee(Math.abs(currentInsurerCharge).toFixed(2)));
        dispatch(setSelectInsurerTypes(selectInsurerType));
        dispatch(setAIDepositPrice(aIdepositAmount.toFixed(2)));
        dispatch(setAIMonthlyRepayment(aImonthlyRepaymentTotal.toFixed(2)));
        dispatch(setAIFullPrice(parseFloat(alternativeTotalPayInFull).toFixed(2)));
        dispatch(setAIMonthlyFull(parseFloat(aItotalPayMonthly).toFixed(2)));
        dispatch(setUserEmail(email));
        dispatch(setSelectAiInsurerTypes(selectAiInsurerType));
        dispatch(setAiTotaChargeCredit(diffrentBetweenYearlyAndMonthlyAi.toFixed(2)))
        if (!userData) {
            navigate('/');
        }
    }, [email, aItotalPayMonthly, aImonthlyRepaymentTotal, aIdepositAmount, currentInsurerCharge, diffrentBetweenYearlyAndMonthly, diffrentBetweenYearlyAndMonthlyAi, selectAiInsurerType, selectInsurerType, plan, totalPayInFull, alternativeTotalPayInFull, totalPayMonthly, monthlyRepaymentTotal, depositAmount, userData, dispatch, navigate]);


    const addonStatus = {
        legalPurchased: selectedAddons.includes("legal") ? "Yes" : "",
        emergencyPurchased: selectedAddons.includes("emergency") ? "Yes" : "",
        keysPurchased: selectedAddons.includes("key") ? "Yes" : "",
        gadgetPurchased: selectedAddons.includes("gadget") ? "Yes" : "",
    };

    // console.log("Insurer Price: "+ totalPayInFull)

    const referenceCode = localStorage.getItem('loginData');
    const refData = JSON.parse(referenceCode);

    return (
        <div className='page-main-area'>
            {/* Payment form removed from here, navigated to Address instead */}

            {loading ? <Loading /> : null}
            {userLoginType === "Lapse" && <ReviewQuoteDetails userData={userData} refData={refData} />}
            {productBothPrices ? <div className={hideBothProductPopup ? "product-both-prices-popup hide" : "product-both-prices-popup"} >
                <div className='product-both-prices-popup-content'>
                    <h1>Choose Your Insurer</h1>
                    <p>We have sourced an excellent, cheaper, alternative policy from our panel of insurers with Ark Home Guard Silver to replace your current policy with AXA Insurance. Please select if you wish to renew with the current insurer or alternative Insurer.</p>
                    {error && (
                        <div className="text-danger text-center mb-3">
                            {error}
                        </div>
                    )}
                    <Row>
                        <Col md={6}>
                            <div className='product-both-prices'>
                                <input type='radio' name='bothPrice' id='currentInsurer' value="currentInsurer" />
                                <label htmlFor='currentInsurer'>
                                    <div className='icon'>
                                        <FontAwesomeIcon icon={faCircleDot} />
                                    </div>
                                    <h4>Current Insurer</h4>
                                    <ul>
                                        <li><b>Annual Payment:</b> £{parseFloat(totalPayInFull).toFixed(2)} per year</li>
                                        <li><b>Monthly Payment:</b> £{parseFloat(monthlyRepaymentTotal).toFixed(2)} per month</li>
                                    </ul>
                                </label>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className='product-both-prices'>
                                <input type='radio' name='bothPrice' id='alternativeInsurer' value="alternativeInsurer" />
                                <label htmlFor='alternativeInsurer'>
                                    <div className='icon'>
                                        <FontAwesomeIcon icon={faCircleDot} />
                                    </div>
                                    <h4>Alternative Insurer</h4>
                                    <ul>
                                        <li><b>Annual Payment:</b> £{parseFloat(alternativeTotalPayInFull).toFixed(2)} per year</li>
                                        <li><b>Monthly Payment:</b> £{parseFloat(aImonthlyRepaymentTotal).toFixed(2)} per month</li>
                                    </ul>
                                </label>
                            </div>
                        </Col>
                    </Row>
                    <div className='text-center mt-4'>
                        <button className='btn btn-primary' onClick={handelSelectInsurerType}>Proceed</button>
                    </div>
                </div>
            </div> : null}
            <Header />
            <div className='product-page-main-area hero-session'>
                <div className='banner-main container'>
                    <img src={bannerImage} alt="banner" />
                </div>
                <Container fluid>
                    <Container>
                        <Row>
                            <Col md={8}>
                                <div className='product-details-left'>
                                    {showAlternativePrices ?<p>Your current insurer <b>Paragon Noble</b> is not offering terms for the coming year. While they will not be offering renewal terms, we have
                                        secured an excellent alternative policy from our panel of insurers <b>with Orwell Insurance</b>.</p> : null}
                                    <p>
                                        Hi{" "}
                                        {userData?.ProposerDetails?.[1]
                                            ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"] ?? ""
                                            : userData?.ProposerDetails?.["Proposer.Person.Forenames"]}
                                        , thank you for choosing ThamesBank Insurance Services to arrange your home insurance for {" "}
                                        {[
                                            userData?.HomeDetails?.["Home.Address.AddrLine1"],
                                            userData?.HomeDetails?.["Home.Address.AddrLine2"],
                                            userData?.HomeDetails?.["Home.Address.AddrLine3"],
                                            userData?.HomeDetails?.["Home.Address.AddrLine4"],
                                            userData?.HomeDetails?.["Home.Address.AddrPostCode"],
                                        ]
                                            .filter(Boolean)
                                            .join(", ")}
                                        .
                                    </p>
                                    <p>Please select your preferred payment method from the options below:</p>

                                    <h1 className='mb-20'>1. Select Your Payment Method</h1>
                                    <div className='select-payment-plan'>
                                        <Row>

                                            <Col lg={6}>
                                                <div
                                                    className={`payment-plan-card month-card ${plan.type === 'monthly' ? 'selected' : ''}`}
                                                    onClick={() => handlePlanChange({ target: { value: 'monthly' } })}
                                                >
                                                    <div className="plan-badge">PER MONTH</div>
                                                    <div className='plan-card-body'>
                                                        <div className='plan-left-col'>
                                                            <h1 className='plan-price-display'>£{productBothPrices ?
                                                                selectInsurerType.type === 'currentInsurer' ? parseFloat(monthlyRepaymentTotal).toFixed(2) : parseFloat(aImonthlyRepaymentTotal).toFixed(2) :
                                                                parseFloat(monthlyRepaymentTotal).toFixed(2)}</h1>
                                                            <p className='plan-desc-text payable-label'>10 Instalments</p>
                                                            <p className='plan-desc-text payable-label'>Deposit: £{productBothPrices ?
                                                                selectInsurerType.type === 'currentInsurer' ? parseFloat(depositAmount).toFixed(2) : parseFloat(aIdepositAmount).toFixed(2) :
                                                                parseFloat(depositAmount).toFixed(2)} </p>
                                                            <p className='plan-desc-text payable-label'>Total Payable: £{productBothPrices ?
                                                                selectInsurerType.type === 'currentInsurer' ? parseFloat(totalPayMonthly).toFixed(2) : parseFloat(aItotalPayMonthly).toFixed(2) :
                                                                parseFloat(totalPayMonthly).toFixed(2)} </p>
                                                            <div className='plan-card-icons'>
                                                                <img src={directDebit} alt="Direct Debit" />
                                                            </div>
                                                        </div>
                                                        <div className='plan-right-col'>
                                                            <ul className="plan-benefits-list">
                                                                {/* <li>
                                                                    <div className='breakdown-row'>
                                                                        <span className='breakdown-label'><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Deposit payable:</span>
                                                                        <b>£{productBothPrices ?
                                                                            selectInsurerType.type === 'currentInsurer' ? parseFloat(depositAmount).toFixed(2) : parseFloat(aIdepositAmount).toFixed(2) :
                                                                            parseFloat(depositAmount).toFixed(2)}</b>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className='breakdown-row'>
                                                                        <span className='breakdown-label'><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> 11 monthly payments of:</span>
                                                                        <b>£{productBothPrices ?
                                                                            selectInsurerType.type === 'currentInsurer' ? parseFloat(monthlyRepaymentTotal).toFixed(2) : parseFloat(aImonthlyRepaymentTotal).toFixed(2) :
                                                                            parseFloat(monthlyRepaymentTotal).toFixed(2)}</b>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className='breakdown-row'>
                                                                        <span className='breakdown-label'><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Total payable:</span>
                                                                        <b>£{productBothPrices ?
                                                                            selectInsurerType.type === 'currentInsurer' ? parseFloat(totalPayMonthly).toFixed(2) : parseFloat(aItotalPayMonthly).toFixed(2) :
                                                                            parseFloat(totalPayMonthly).toFixed(2)}</b>
                                                                    </div>
                                                                </li> */}
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Spread the cost </li>
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Predictable monthly payments</li>
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Quick and easy set-up </li>
                                                                {/* <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Professional Advisor</li>
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> 24/7 Support</li> */}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <button className="plan-action-btn">Pay Monthly</button>
                                                </div>
                                            </Col>
                                            <Col lg={6} className="mb-4 mb-md-0 mt-class">
                                                <div
                                                    className={`payment-plan-card year-card ${plan.type === 'yearly' ? 'selected' : ''}`}
                                                    onClick={() => handlePlanChange({ target: { value: 'yearly' } })}
                                                >
                                                    <div className="plan-badge color-dark">PER YEAR</div>
                                                    <div className='plan-card-body'>
                                                        <div className='plan-left-col'>
                                                            <h1 className='plan-price-display'>£{productBothPrices ?
                                                                selectInsurerType.type === 'currentInsurer' ? parseFloat(totalPayInFull).toFixed(2) : parseFloat(alternativeTotalPayInFull).toFixed(2) :
                                                                parseFloat(totalPayInFull).toFixed(2)}</h1>
                                                            <p className='plan-desc-text'>Payment can be made by debit or credit card.</p>
                                                            <div className='plan-card-icons'>
                                                                <img src={visaMasterImage} alt="Visa Mastercard" />
                                                            </div>
                                                        </div>
                                                        <div className='plan-right-col'>
                                                            <ul className="plan-benefits-list">
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> One simple annual payment</li>
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Lower overall cost</li>
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Straightforward annual option </li>
                                                                {/* <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> Professional Advisor</li>
                                                                <li><FontAwesomeIcon icon={faArrowRight} className='plan-arrow-icon' /> No Brokers, No Upselling</li> */}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <button className="plan-action-btn">Pay in Full</button>
                                                </div>
                                            </Col>

                                        </Row>
                                    </div>
                                    <h1>2. Optional Extras</h1>
                                    <p className='mb-3'>Enhance your cover by adding one or more of the optional extra offered below</p>
                                    <div className="addson-main">
                                        <Accordion alwaysOpen>
                                            <Accordion.Item eventKey="0" className={selectedAddons.includes('legal') ? 'addon-active' : ''}>
                                                <Accordion.Header>
                                                    <div className='addon-header-left'>
                                                        <img src={legalIcon} alt='icon' />
                                                        <h3>
                                                            Family Legal Protection
                                                            <span>Protect yourself from unexpected legal disputes, with up to £75,000 of cover</span>
                                                        </h3>
                                                    </div>
                                                    <div className="accordion-icon-main">
                                                        <span>
                                                            £{plan.type === 'yearly' ? parseFloat(addonPrices.legal).toFixed(2) : addonMonthlyPayments.legal} {plan.type === 'yearly' ? 'Per Year' : 'Per Month'}
                                                        </span>
                                                        <div className="accordion-icone ms-3">

                                                            <button
                                                                className={`button-class`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleAddon('legal');
                                                                }}
                                                            >
                                                                {selectedAddons.includes('legal')
                                                                    ? <><FontAwesomeIcon icon={faCheck} className="me-1" /></>
                                                                    : <FontAwesomeIcon icon={faPlus} />
                                                                }
                                                            </button>

                                                        </div>
                                                        <div className="accordion-icon ms-3">
                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>

                                                    <h4>About Family Legal</h4>
                                                    <p>
                                                        When legal problems arise, having expert support can make all the difference. Family Legal
                                                        Protection provides you and your family with access to qualified legal professionals, plus up to
                                                        £75,000 of cover towards legal costs, giving you confidence and peace of mind when disputes
                                                        become complex.
                                                    </p>

                                                    <p>You’ll benefit from:</p>

                                                    <ul className="list-unstyled">
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>24/7 free legal advice for personal, property and employment matters</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Personal injury cover, including rehabilitation costs up to £5,000</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Employment disputes, with legal expenses up to £25,000</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Defence for certain criminal prosecutions (non-motor, non-business)</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Tax protection for HMRC enquiries and investigations</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Contract dispute cover for your home or everyday goods and services</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Property protection for nuisance, trespass or damage issues</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Education disputes, with legal costs up to £5,000</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Probate and will disputes involving immediate family members</span>
                                                        </li>
                                                    </ul>

                                                    <h5 className="mt-3">Eligibility</h5>
                                                    <ul className="list-unstyled">
                                                        <li className="text-muted" style={{ fontSize: '0.9rem' }}>

                                                            ⦁  Cover applies only to your main permanent UK residence and excludes unoccupied, holiday or weekend homes
                                                        </li>
                                                    </ul>
                                                    <div className='accordion-body-buttons'>
                                                        <p className="mb-3">
                                                            View full <a href='https://www.paragon-uk.net/_files/ugd/d84514_45e6852833fc45168d6ec8d1aae6ed80.pdf' rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered
                                                            {/* View full <a href={userData?.AddonPrices?.LegalDocs} rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered */}
                                                        </p>
                                                        {/* <a href={userData?.AddonPrices?.LegalDocs} rel="noreferrer" target='_blank'>Download full T&Cs</a> */}
                                                        <button className={selectedAddons.includes('legal') ? 'btn btn-secondry' : 'btn btn-success'} onClick={() => toggleAddon('legal')}>
                                                            <FontAwesomeIcon icon={selectedAddons.includes('legal') ? faMinus : faPlus} />
                                                            {selectedAddons.includes('legal') ? 'Remove this cover' : 'Add this cover'}
                                                        </button>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1" className={selectedAddons.includes('emergency') ? 'addon-active' : ''}>
                                                <Accordion.Header>
                                                    <div className='addon-header-left'>
                                                        <img src={emergencyIcon} alt='icon' />
                                                        <h3>
                                                            Home Emergency
                                                            {/* <span>Protect Your Home in an Emergency</span> */}
                                                            <span>Target 4-hour response — day or night </span>
                                                        </h3>
                                                    </div>
                                                    <div className="accordion-icon-main">
                                                        <span>
                                                            £{plan.type === 'yearly' ? parseFloat(addonPrices.emergency).toFixed(2) : parseFloat(addonMonthlyPayments.emergency).toFixed(2)} {plan.type === 'yearly' ? 'Per Year' : 'Per Month'}
                                                        </span>

                                                        <div className="accordion-icone ms-3">
                                                            <button
                                                                className={`button-class`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleAddon('emergency');
                                                                }}
                                                            >
                                                                {selectedAddons.includes('emergency')
                                                                    ? <><FontAwesomeIcon icon={faCheck} className="me-1" /></>
                                                                    : <FontAwesomeIcon icon={faPlus} />
                                                                }
                                                            </button>
                                                        </div>
                                                        <div className="accordion-icon ms-3">
                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <h4>About Home Emergency</h4>

                                                    <p>
                                                        When your heating fails, a pipe bursts or you can’t secure your home, you need help fast.
                                                        Home Emergency Cover gives you 24/7 access to a nationwide network of approved contractors
                                                        arranged on your behalf, with a <strong>target response time of just four hours</strong>,
                                                        so problems can be fixed quickly and safely.
                                                    </p>

                                                    <p>You’ll benefit from:</p>
                                                    <ul className="list-unstyled">
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span>Help with <strong>burst or leaking pipes</strong> and <strong>domestic hot-water failures</strong></span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span><strong>Emergency roof repairs</strong> to stop internal water damage</span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span><strong>Break-in or vandalism</strong> response to make your home secure</span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span><strong>Inoperable toilet</strong> repairs (where only one exists in the property)</span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span><strong>Pest removal</strong> for wasps, field or house mice, or brown rats inside your home</span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span><strong>Overnight accommodation</strong> if your home becomes uninhabitable (up to £250)</span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                                style={{ minWidth: '16px' }}
                                                            />
                                                            <span><strong>No call-out fees or excess to pay</strong>, with a £500 limit per claim for parts, labour and materials</span>
                                                        </li>

                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                className="text-success me-2"
                                                            />
                                                            <span><strong>Quality-approved contractors</strong>, covering urgent repairs up to your policy limit</span>
                                                        </li>

                                                    </ul>

                                                    <h5 className="mt-3">Eligibility</h5>
                                                    <ul className="list-unstyled">
                                                        <li className="text-muted" style={{ fontSize: '0.9rem' }}>

                                                            ⦁  Cover applies only to your main permanent UK residence and excludes unoccupied, holiday or weekend homes
                                                        </li>
                                                    </ul>
                                                    <div className='accordion-body-buttons'>

                                                        {/* <a href={userData?.AddonPrices?.EmergencyDocs} rel="noreferrer" target='_blank'>Download full T&Cs</a> */}
                                                        <p className="mb-3">
                                                            View full <a href='https://www.paragon-uk.net/_files/ugd/d84514_4257e6063e79498b8156c0604a219bf2.pdf' rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered
                                                            {/* View full <a href={userData?.AddonPrices?.EmergencyDocs} rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered */}
                                                        </p>
                                                        <button className={selectedAddons.includes('emergency') ? 'btn btn-secondry' : 'btn btn-success'} onClick={() => toggleAddon('emergency')}>
                                                            <FontAwesomeIcon icon={selectedAddons.includes('emergency') ? faMinus : faPlus} />
                                                            {selectedAddons.includes('emergency') ? 'Remove this cover' : 'Add this cover'}
                                                        </button>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="2" className={selectedAddons.includes('key') ? 'addon-active' : ''}>
                                                <Accordion.Header>
                                                    <div className='addon-header-left'>
                                                        <img src={keyIcon} alt='icon' />
                                                        <h3>
                                                            Key Cover
                                                            <span>24/7 protection for your home and car keys</span>
                                                            {/* <span>Key Protection</span> */}
                                                        </h3>
                                                    </div>
                                                    <div className="accordion-icon-main">
                                                        <span>
                                                            £{plan.type === 'yearly' ? parseFloat(addonPrices.key).toFixed(2) : addonMonthlyPayments.key} {plan.type === 'yearly' ? 'Per Year' : 'Per Month'}
                                                        </span>

                                                        <div className="accordion-icone ms-3">
                                                            <button
                                                                className={`button-class`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleAddon('key');
                                                                }}
                                                            >
                                                                {selectedAddons.includes('key')
                                                                    ? <><FontAwesomeIcon icon={faCheck} className="me-1" /></>
                                                                    : <FontAwesomeIcon icon={faPlus} />
                                                                }
                                                            </button>
                                                        </div>
                                                        <div className="accordion-icon ms-3">
                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>

                                                    <h4>About Key Protection</h4>
                                                    <p>
                                                        Losing your keys or having them stolen is stressful and often costly. <strong>Key Protection Insurance</strong> gives you round-the-clock access to a specialist helpline that arranges locksmiths, replacement keys and emergency assistance whenever you need it.
                                                    </p>

                                                    <p className="fw-bold">You’ll benefit from:</p>
                                                    <ul className="list-unstyled">
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Up to <strong>£1,500</strong> towards locksmith charges, replacement locks <em>(if there’s a security risk)</em> and new keys if yours are <strong>lost, stolen or damaged</strong></span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Cover for <strong>car keys</strong>, including <strong>immobilisers and alarms</strong> that are integral to the key</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Up to <strong>3 days’ car hire</strong> <em>(£40 per day)</em> or <strong>£100 onward travel</strong> if you can’t use your vehicle</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Up to <strong>£100 overnight accommodation</strong> if you cannot access your vehicle or home</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span><strong>No excess to pay</strong> and <strong>no need to claim on your home insurance</strong></span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span><strong>24-hour emergency helpline</strong>, 365 days a year</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span><strong>No call-out fees</strong>, with approved locksmiths and contractors <strong>arranged on your behalf</strong></span>
                                                        </li>
                                                    </ul>

                                                    <h5 className="mt-3">Eligibility:</h5>
                                                    <p className="text-muted" style={{ fontSize: '0.9rem' }}>
                                                        ⦁ Cover applies to <strong>keys for your main residence and vehicles within your household.</strong>
                                                    </p>

                                                    <div className='accordion-body-buttons'>
                                                        <p className="mb-3">
                                                            View full <a href='https://www.paragon-uk.net/_files/ugd/d84514_787eda25f6e04a89b57eb64e64364a5d.pdf' rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered
                                                            {/* View full <a href={userData?.AddonPrices?.KeyDocs} rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered */}
                                                        </p>
                                                        <button className={selectedAddons.includes('key') ? 'btn btn-secondry' : 'btn btn-success'} onClick={() => toggleAddon('key')}>
                                                            <FontAwesomeIcon icon={selectedAddons.includes('key') ? faMinus : faPlus} />
                                                            {selectedAddons.includes('key') ? ' Remove this cover' : ' Add this cover'}
                                                        </button>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="3" className={selectedAddons.includes('gadget') ? 'addon-active' : ''}>
                                                <Accordion.Header>
                                                    <div className='addon-header-left'>
                                                        <img src={gadgetIcon} alt='icon' />
                                                        <h3>
                                                            Gadget Cover
                                                            <span>Up to £1,000 Protection for Every Gadget</span>
                                                            {/* <span>Gadget Cover</span> */}
                                                        </h3>
                                                    </div>
                                                    <div className="accordion-icon-main">
                                                        <span>
                                                            £{plan.type === 'yearly' ? parseFloat(addonPrices.gadget).toFixed(2) : addonMonthlyPayments.gadget} {plan.type === 'yearly' ? 'Per Year' : 'Per Month'}
                                                        </span>

                                                        <div className="accordion-icone ms-3">
                                                            <button
                                                                className={`button-class`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleAddon('gadget');
                                                                }}
                                                            >
                                                                {selectedAddons.includes('gadget')
                                                                    ? <><FontAwesomeIcon icon={faCheck} className="me-1" /></>
                                                                    : <FontAwesomeIcon icon={faPlus} />
                                                                }
                                                            </button>                                                     </div>
                                                        <div className="accordion-icon ms-3">
                                                            <FontAwesomeIcon icon={faChevronDown} />
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <h4 className='d-flex justify-content-between'>
                                                        {/* £500 Gadget Cover In and Out of Car */}
                                                        {/* <span>£65.00/per year</span> */}
                                                    </h4>
                                                    
                                                    <p className="mb-3">When your phone slips from your hand, your tablet is lost or your gadget is stolen, the disruption can be frustrating and costly. Gadget Cover protects your family’s portable devices against unexpected damage and theft, helping you get back up and running quickly.    </p>
                                                        <p class="fw-bold">You’ll benefit from:</p>

                                                   
                                                    <ul className="list-unstyled">
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Accidental damage cover, including drops, cracks and liquid damage</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Theft protection (subject to security conditions)</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Accidental loss cover for mobile phones and tablets</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Electrical or mechanical breakdown cover outside the manufacturer’s warranty (excluding laptops)</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Unauthorised call, text and data usage cover for mobiles (up to £1,000)</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Accessory cover up to £150 when lost, stolen or damaged at the same time as your gadget</span>
                                                        </li>
                                                        <li className="mb-2 d-flex align-items-center">
                                                            <FontAwesomeIcon icon={faCheckCircle} className="text-success me-2" style={{ minWidth: '16px' }} />
                                                            <span>Repair or replacement arranged on your behalf, based on the gadget’s age and condition</span>
                                                        </li>
                                                    </ul>
                                                     <h5 className="mt-3">Eligibility</h5>
                                                    <ul className="list-unstyled">
                                                        <li className="text-muted align-items-center" style={{ fontSize: '0.9rem' }}>

                                                            ⦁  Cover applies to gadgets less than 3 years old at the start of cover, purchased new in the UK (or refurbished with a minimum 12-month warranty), with proof of ownership available, and insured under an active home or motor policy with us.
                                                        </li>
                                                    </ul>
                                                    {/* <p>Get Protection for all your family's portable gadgets including Mobile / Smart Phones / Cameras /Laptops / Tablets / MP3 Players / Game Consoles & Sat Navs either in your car or outside your home under one simple policy (this does not affect your home insurance)</p> */}
                                                    <div className='accordion-body-buttons'>
                                                        {/* <a href={userData?.AddonPrices?.GadgetDocs} rel="noreferrer" target='_blank'>Download full T&Cs</a> */}
                                                        {/* <p className="mb-3">
                                                            View full <a href={userData?.AddonPrices?.GadgetDocs} rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered
                                                        </p> */}
                                                        <p className="mb-3 ml-5">
                                                            View full <a href='https://www.paragon-uk.net/_files/ugd/d84514_45e6852833fc45168d6ec8d1aae6ed80.pdf' rel="noreferrer" target='_blank' className="text-decoration-underline">Policy Terms & Conditions</a> to see exactly what’s covered
                                                        </p>
                                                        <button className={selectedAddons.includes('gadget') ? 'btn btn-secondry' : 'btn btn-success'} onClick={() => toggleAddon('gadget')}>
                                                            <FontAwesomeIcon icon={selectedAddons.includes('gadget') ? faMinus : faPlus} />
                                                            {selectedAddons.includes('gadget') ? 'Remove this cover' : 'Add this cover'}
                                                        </button>
                                                    </div>

                                                    {/* <h4 className='d-flex justify-content-between mt-4'>
                                                        £1,000 Gadget Cover In and Out of Car
                                                        <span>£65.00/per year</span>
                                                    </h4>
                                                    <p>Get Protection for all your family's portable gadgets including Mobile / Smart Phones / Cameras /Laptops / Tablets / MP3 Players / Game Consoles & Sat Navs either in your car or outside your home under one simple policy (this does not affect your home insurance)</p>
                                                    <div className='accordion-body-buttons'>
                                                        <a href={userData?.AddonPrices?.GadgetDocs} rel="noreferrer" target='_blank'>Download full T&Cs</a>
                                                        <button className={selectedAddons.includes('gadget') ? 'btn btn-success' : 'btn btn-secondry'} onClick={() => toggleAddon('gadget')}>
                                                            <FontAwesomeIcon icon={selectedAddons.includes('gadget') ? faMinus : faPlus} />
                                                            {selectedAddons.includes('gadget') ? 'Remove this cover' : 'Add this cover'}
                                                        </button>
                                                    </div> */}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>


                                    </div>

                                    <div className='term-box-main'>
                                        <h1 className='mb-3 mt-0'>3. Terms & Conditions</h1>

                                        <div className="mb-3 d-flex align-items-center">
                                            <FontAwesomeIcon icon={faCheckCircle} className='text-success me-2 mt-1' />
                                            <div>
                                                <h5 className="fw-bold mb-1">Policy Review Confirmation</h5>
                                                <p className="mb-0">
                                                    {userLoginType === "Lapse" ?
                                                        <>I have reviewed the rating information my quote is based upon and confirm they are correct & the policy offered meets my needs.</>
                                                        : <> I have reviewed all policy documents provided in my customer portal and that the cover, limits, and details meet my needs and requirements.</>}
                                                </p>
                                                <p className="mb-0">I understand this policy has been arranged on a non-advised basis and no personal recommendation has been given.</p>
                                            </div>
                                        </div>

                                        <div className="mb-3 d-flex align-items-center">
                                            <FontAwesomeIcon icon={faCheckCircle} className='text-success me-2 mt-1' />
                                            <div>
                                                <h5 className="fw-bold mb-1">Endorsements Confirmation</h5>
                                                <p className="mb-0">
                                                    I have reviewed and understood the endorsements that apply to my policy and acknowledge that they form part of my cover.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="mb-3 d-flex align-items-center">
                                            <FontAwesomeIcon icon={faCheckCircle} className='text-success me-2 mt-1' />
                                            <div>
                                                <h5 className="fw-bold mb-1">Terms and Conditions</h5>
                                                <p className="mb-0">
                                                    I have read and agreed to the <a href='https://docs.thamesbankinsurance.co.uk/Terms/Terms%20Of%20Business.pdf' rel="noreferrer" target='_blank' style={{ fontWeight: 'bold' }}>Thamesbank Terms of Business</a>, which explain how my policy will be administered.
                                                </p>
                                            </div>
                                        </div>

                                        <div ref={termsRef} className="mt-4">
                                            <Form.Check
                                                inline
                                                label="I confirm I’ve read and agreed to all of the above 1. Policy Review; 2. Endorsements Confirmation; and 3. Terms of Business."
                                                name="termcondation"
                                                type="checkbox"
                                                id="termcondation"
                                                checked={isTermsChecked}
                                                onChange={handleCheckboxChange}
                                            />
                                            {error && <Alert variant="danger" className='mt-3'>{error}</Alert>}
                                            {/* {isTermsChecked &&  <Alert variant="success" className='mt-3'>I have read and agree with the information above and the Terms and Conditions.</Alert>} */}
                                        </div>
                                        <Form.Group className="mb-2 mt-4 text-start" controlId="email" style={{ maxWidth: '400px', width: '100%' }} ref={termsRef}>
                                            <Form.Check
                                                inline
                                                label="Please confirm your email:"
                                                name="checkEmail"
                                                type="checkbox"
                                                id="checkEmail"
                                                checked={checkEmail}
                                                onChange={handleEmailCheckboxChange}
                                                className='mb-2'
                                            />
                                            <Form.Control type="email" placeholder="Please Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} className={`userEmail mt-4 ${emailError ? 'is-invalid' : ''}`} />
                                            {emailError && <div className="invalid-feedback d-block">{emailError}</div>}
                                            {checkEmailError && <Alert variant="danger" className='mt-3'>{checkEmailError}</Alert>}
                                        </Form.Group>
                                    </div>

                                    <div className='price-summary mb-0' ref={summaryRef}>
                                        <h1 className='mb-3 mt-3'>Price Summary</h1>
                                        {plan.type === 'yearly' ?
                                            <p className='summary-detail-text'>
                                                <span>You have selected to pay the premium in full. The total premium payable is £{selectAiInsurerType.type === 'alternativeInsurer' ? parseFloat(alternativeTotalPayInFull).toFixed(2) : parseFloat(totalPayInFull).toFixed(2)} (Inclusive of Insurance Premium Tax).</span>
                                            </p> :
                                            <p className='summary-detail-text'>
                                                <span>You’ve chosen to pay for your policy by monthly instalments, giving you the flexibility to spread the cost rather than paying in full upfront. <br></br>
                                                    
                                                     The instalment facility is arranged through PremFina Ltd, subject to status, and a basic credit check will be carried out
                                                     <br></br>
                                                      Choosing monthly instalments means the overall amount payable will be <strong>£{selectAiInsurerType.type === 'alternativeInsurer' ? diffrentBetweenYearlyAndMonthlyAi.toFixed(2) : diffrentBetweenYearlyAndMonthly.toFixed(2)}</strong> more than paying in full, with a full breakdown shown in the table below
                                                      <br></br>
                                                      Please review the pre-contract terms and confirm your consent to proceed</span>
                                            </p>}
                                        {/* --- NEW RESPONSIVE PRICE SUMMARY --- */}
                                        <div className="price-summary-list">
                                            {/* Desktop-Only Header */}
                                            <div className="price-item price-header d-none d-md-flex">
                                                <div className="price-label"></div>
                                                <div className="price-full">Pay in Full</div>
                                                {plan.type !== 'yearly' && <div className="price-monthly">Pay Monthly</div>}
                                            </div>

                                            {/* --- Premium --- */}
                                            {userLoginType === "Failed Payment" ? (
                                                <div className="price-item">
                                                    <div className="price-label">Premium</div>
                                                    <div className="price-full" data-label="Pay in Full">£{summaryData.premium}</div>
                                                    {plan.type !== 'yearly' && <div className="price-monthly" data-label="Pay Monthly">£{summaryData.premium}</div>}
                                                </div>
                                            ) : (
                                                <>
                                                    {summaryData.showCurrent && (
                                                        <div className="price-item">
                                                            <div className="price-label">Premium</div>
                                                            <div className="price-full" data-label="Pay in Full">£{summaryData.currentPremium}</div>
                                                            {plan.type !== 'yearly' && <div className="price-monthly" data-label="Pay Monthly">£{summaryData.currentPremium}</div>}
                                                        </div>
                                                    )}
                                                    {summaryData.showAlternative && (
                                                        <div className="price-item">
                                                            <div className="price-label">Alternative Premium</div>
                                                            <div className="price-full" data-label="Pay in Full">£{summaryData.alternativePremium}</div>
                                                            {plan.type !== 'yearly' && <div className="price-monthly" data-label="Pay Monthly">£{summaryData.alternativePremium}</div>}
                                                        </div>
                                                    )}
                                                    {summaryData.showBoth && (
                                                        <div className="price-item">
                                                            <div className="price-label">{selectInsurerType.type === 'currentInsurer' ? 'Premium' : 'Alternative Premium'}</div>
                                                            <div className="price-full" data-label="Pay in Full">
                                                                £{selectInsurerType.type === 'currentInsurer' ? summaryData.currentPremium : summaryData.alternativePremium}
                                                            </div>
                                                            {plan.type !== 'yearly' && (
                                                                <div className="price-monthly" data-label="Pay Monthly">
                                                                    £{selectInsurerType.type === 'currentInsurer' ? summaryData.currentPremium : summaryData.alternativePremium}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            {/* --- Broker Fee --- */}
                                            <div className="price-item">
                                                <div className="price-label">{isBrokerDiscount ? "Broker Discount " : "Broker Fee "}</div>
                                                <div className="price-full" data-label="Pay in Full">{isBrokerDiscount ? "-" : ""}£{Math.abs(currentInsurerCharge).toFixed(2)}</div>
                                                {plan.type !== 'yearly' && <div className="price-monthly" data-label="Pay Monthly">{isBrokerDiscount ? "-" : ""}£{Math.abs(currentInsurerCharge).toFixed(2)}</div>}
                                            </div>

                                            {/* --- Monthly-Only Rows --- */}
                                            {plan.type !== 'yearly' && (
                                                <>
                                                    <div className="price-item">
                                                        <div className="price-label">Instalment Fee</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">£5.00</div>
                                                    </div>
                                                    <div className="price-item">
                                                        <div className="price-label">Deposit</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">
                                                            £{productBothPrices ? (selectInsurerType.type === 'currentInsurer' ? depositAmount.toFixed(2) : aIdepositAmount.toFixed(2)) : depositAmount.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="price-item">
                                                        <div className="price-label">1st monthly repayment</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">
                                                            £{productBothPrices ? (selectInsurerType.type === 'currentInsurer' ? (parseFloat(monthlyRepaymentTotal) + 5).toFixed(2) : (parseFloat(aImonthlyRepaymentTotal) + 5).toFixed(2)) : (parseFloat(monthlyRepaymentTotal) + 5).toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="price-item">
                                                        <div className="price-label">10 monthly repayments</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">
                                                            £{productBothPrices ? (selectInsurerType.type === 'currentInsurer' ? monthlyRepaymentTotal.toFixed(2) : aImonthlyRepaymentTotal.toFixed(2)) : monthlyRepaymentTotal.toFixed(2)}
                                                        </div>
                                                    </div>
                                                    <div className="price-item">
                                                        <div className="price-label">Interest rate</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">14%</div>
                                                    </div>
                                                    <div className="price-item">
                                                        <div className="price-label">Total charge for credit</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">£{selectAiInsurerType.type === 'alternativeInsurer' ? diffrentBetweenYearlyAndMonthlyAi.toFixed(2) : diffrentBetweenYearlyAndMonthly.toFixed(2)}</div>
                                                    </div>
                                                    <div className="price-item">
                                                        <div className="price-label">APR (Variable)</div>
                                                        <div className="price-full" data-label="Pay in Full">-</div>
                                                        <div className="price-monthly" data-label="Pay Monthly">29.24%</div>
                                                    </div>
                                                </>
                                            )}

                                            {/* --- Addons --- */}
                                            {selectedAddons.length > 0 && (
                                                <>
                                                    <div className="price-item price-subheader">
                                                        <div className="price-label"><h4>Optional Extras</h4></div>
                                                    </div>
                                                    {selectedAddons.map((addon) => {
                                                        const addonPrice = parseFloat(addonPrices?.[addon]) || 0;
                                                        const addonPriceMonthly = parseFloat(addonMonthlyPayments?.[addon]) || 0;
                                                        return (
                                                            <div className="price-item" key={addon}>
                                                                <div className="price-label">{addon.charAt(0).toUpperCase() + addon.slice(1)}</div>
                                                                <div className="price-full" data-label="Pay in Full">£{addonPrice.toFixed(2)}</div>
                                                                {plan.type !== 'yearly' && <div className="price-monthly" data-label="Pay Monthly">£{addonPriceMonthly.toFixed(2)}</div>}
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            )}

                                            {/* --- Total Row --- */}
                                            <div className="price-item total-row">
                                                <div className="price-label">Total Amount Payable</div>
                                                <div className="price-full" data-label="Pay in Full">
                                                    <strong>£{productBothPrices ? (selectInsurerType.type === 'currentInsurer' ? parseFloat(totalPayInFull).toFixed(2) : parseFloat(alternativeTotalPayInFull).toFixed(2)) : parseFloat(totalPayInFull).toFixed(2)}</strong>
                                                </div>
                                                {plan.type !== 'yearly' && (
                                                    <div className="price-monthly" data-label="Pay Monthly">
                                                        <strong>£{productBothPrices ? (selectInsurerType.type === 'currentInsurer' ? parseFloat(totalPayMonthly).toFixed(2) : parseFloat(aItotalPayMonthly).toFixed(2)) : parseFloat(totalPayMonthly).toFixed(2)}</strong>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* --- END RESPONSIVE PRICE SUMMARY --- */}
                                        <div className='text-end mt-4'>
                                            <button className='btn btn-primary' onClick={handleSubmit}>Proceed to Payment</button>
                                        </div>
                                        {/* <ul>
                                            <li><p>Current Insurer Premium <span>£{userData?.paymentDetails?.currentInsurerPremium?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Current Insurer Charge <span>£{userData?.paymentDetails?.currentInsurerCharge?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Current Insurer Total <span>£{userData?.paymentDetails?.currentInsurerTotal?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Alternative Insurer Premium <span>£{userData?.paymentDetails?.alternativeInsurerPremium?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Alternative Insurer Charge <span>£{userData?.paymentDetails?.alternativeInsurerCharge?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Alternative Insurer Total <span>£{userData?.paymentDetails?.alternativeInsurerTotal?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Deposit <span>£{userData?.paymentDetails?.deposit?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Interest <span>£{userData?.paymentDetails?.interest?.toFixed(2) ?? "0.00"}</span></p></li>
                                            <li><p>Payments <span>£{userData?.paymentDetails?.payments?.toFixed(2) ?? "0.00"}</span></p></li>
                                            {selectedAddons.length > 0 && (
                                                <>
                                                <li>
                                                    <h4>Optional Extras</h4>
                                                </li>
                                                {selectedAddons.map((addon) => (
                                                    <li key={addon}>
                                                    <p>
                                                        {addon.charAt(0).toUpperCase() + addon.slice(1)}{' '}
                                                        <span>£{userData?.addonPrices?.[addon]?.toFixed(2) ?? "0.00"}</span>
                                                    </p>
                                                    </li>
                                                ))}
                                                </>
                                            )}

                                            <li className='total'><p>Total Amount Payable <span>£{calculateTotalPrice().toFixed(2)}</span></p></li>
                                            
                                        </ul> */}
                                    </div>
                                </div>
                            </Col>
                            <Col md={4} className="d-md-block">
                                <LeftMenu selectInsurerType={selectInsurerType} productBothPrices={productBothPrices} />
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </div>
            <Footer />
        </div>
    )
}


export default Product;